'use client'

import { dataTestIds } from 'product-card/constants/dataTestIds'
import { ProductCardInteractionProvider } from 'product-card/context/ProductCardInteractionContext/ProductCardInteractionContext'
import { ProductCardRefProvider } from 'product-card/context/ProductCardRefContext'
import { useProductCard } from 'product-card/hooks/useProductCard'
import { useProductCardImpression } from 'product-card/hooks/useProductCardImpression/useProductCardImpression'
import { useShowAsFeatured } from 'product-card/hooks/useShowAsFeatured/useShowAsFeatured'
import { useSyncProductInfo } from 'product-card/hooks/useSyncProductInfo/useSyncProductInfo'
import type { ProductCardBaseProps } from 'product-card/types'
import { useRef } from 'react'
import { cx } from 'utils/cx'
import styles from './ProductCard.module.scss'
import { ProductDetails } from './ProductDetails'
import { ProductImageContainer } from './ProductImageContainer'

export const ProductCard = ({ className }: ProductCardBaseProps) => {
	const productCardRef = useRef<HTMLFormElement | null>(null)

	const { dataTestId } = useProductCard()

	const showAsFeatured = useShowAsFeatured()

	useProductCardImpression({ productCardRef, shouldSendPrice: true })
	useSyncProductInfo()

	return (
		<form
			ref={productCardRef}
			className={cx(styles.productCard, className)}
			data-testid={dataTestId}
		>
			<ProductCardRefProvider initialProductCardRef={productCardRef}>
				<div
					data-testid={
						showAsFeatured
							? dataTestIds.productCardFeatured(dataTestId)
							: undefined
					}
				>
					<ProductCardInteractionProvider>
						<ProductImageContainer />
					</ProductCardInteractionProvider>
					<ProductDetails />
				</div>
			</ProductCardRefProvider>
		</form>
	)
}
